// extracted by mini-css-extract-plugin
export default {"select":"ComplaintFormImpulseErrorDesc-py8He__select"};